import { Controller } from "@hotwired/stimulus"

// Injects the selected "section" checkboxes into each export button_to form
// right before it submits, so async exports (solvency, discounts) honour the
// chosen optional sections without changing the existing POST flow.
//
// Usage:
//   <div data-controller="export-sections">
//     <input type="checkbox" data-export-sections-target="checkbox" value="moratoriums" checked>
//     <form ...><button data-action="mousedown->export-sections#sync">…</button></form>
//   </div>
//
// Each export button lives in its own button_to form; on mousedown we refresh
// the injected hidden inputs in that form to match the checked boxes.
//
// The injected param name defaults to "sections" (solvency export) but can be
// overridden via data-export-sections-param-value (e.g. "columns" for the
// discount assignments export).
export default class extends Controller {
  static targets = ["checkbox"]
  static values = { param: { type: String, default: "sections" } }

  sync(event) {
    const form = event.target.closest("form")
    if (!form) return

    // Remove previously injected hidden inputs
    form
      .querySelectorAll('input[data-export-sections-injected="true"]')
      .forEach((el) => el.remove())

    const selected = this.checkboxTargets
      .filter((cb) => cb.checked)
      .map((cb) => cb.value)

    selected.forEach((value) => {
      const input = document.createElement("input")
      input.type = "hidden"
      input.name = `${this.paramValue}[]`
      input.value = value
      input.dataset.exportSectionsInjected = "true"
      form.appendChild(input)
    })
  }
}
